<!-- 主页 第二版 -->
<template>
  <div class="title">
    <!-- 头部 -->
    <Header></Header>

    <!-- 轮播 -->
    <Hhlianou></Hhlianou>
    <!-- 跳动数据 -->
    <bounceData></bounceData>

    <componentTiile :ittleData="'集采交易 统仓统配 金融赋能'"></componentTiile>
    <!-- 集采交易统仓统配 -->
    <Fixed class="fixed"></Fixed>
    <!--<Navigative></Navigative> -->
    <jicai></jicai>

    <componentTiile :ittleData="'最 新 供 求 商 机'"></componentTiile>
    <!-- 供求商机 -->
    <caigou></caigou>

    <!-- banner图 -->
    <img src alt class="banner" />

    <componentTiile :ittleData="'物 流 服 务'"></componentTiile>
    <wuliu></wuliu>

    <componentTiile :ittleData="'健康美味、原生态的洪湖莲藕'" style="margin-top: 10%;"></componentTiile>
    <clolle></clolle>

    <componentTiile :ittleData="'优 品 推 荐'"></componentTiile>
    <youpin></youpin>

    <componentTiile :ittleData="'行 业 资 讯'"></componentTiile>
    <zixun></zixun>

    <!-- 一键代发 -->
    <img src="https://deiyustatic.oss-cn-beijing.aliyuncs.com/home/image.2558044a.png" alt width="100%" />

    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";
import Fixed from "@/components/fixed";
import Header from "@/components/header";
import Hhlianou from "@/components/hhlianou";
import Footer from "@/components/footer";
import Navigative from "@/components/navigative";
import jicai from "@/components/jicai";
import bounceData from "@/components/bounceData";
import componentTiile from "@/components/title";

import caigou from "./components/caigou.vue";
import youpin from "./youpin/index.vue";
import clolle from "./colle"; // 小轮播
import wuliu from "./wuliu"; // 原生鲜
import zixun from "./zixun";
export default {
  components: {
    zixun,
    Fixed,
    Header,
    clolle,
    caigou,
    wuliu,
    youpin,
    Hhlianou,
    Footer,
    Navigative,
    bounceData,
    componentTiile,
    jicai
  },
  data() {
    return {
      isFixed: false,
      input: "",
      x: 100,
      y: 10
      // recoSt:recommentList1.id,
    };
  },

  methods: {},

  mounted() {},
  computed: {},
  beforeDestroy() {}
};
</script>

<style>
.title {
  width: 100%;
  background-color: rgb(250, 250, 250);
}

@media screen and (max-width: 599px) {
  .fixed {
    display: none;
  }
}
</style>